module.exports = __webpack_public_path__ + "img/piggypunks-animation.f3fdbd68.gif";